import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
// transaction
export function transactionAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,bonus_type,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transaction/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&code=' + code + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&bonus_type=' + bonus_type + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function transactionInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'transaction/info?language='+language+'&id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}
// memberWallet
export function memberWalletAjaxTable(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_wallet/ajaxTable?language='+language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function memberWalletSearch(limit,pagination,id,login1,login2){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	var login;
	if(login1){
		login = login1;
	}else{
		login=login2
	}
	const data = request({
		url: config.url+'report_wallet/ajaxTable?language=' + language + '&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

// inversetment record
export function inversetmentAjaxTable(dateStart,dateEnd,type){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_coin/ajaxTable?date_start=' + dateStart + '&date_end=' + dateEnd  + '&type=' + type,
		method: 'get'
	});

	return Promise.resolve(data);
}

// deposit record
export function depositAjaxTable(dateStart,dateEnd,type){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_deposit/ajaxTable?date_start=' + dateStart + '&date_end=' + dateEnd  + '&type=' + type,
		method: 'get'
	});

	return Promise.resolve(data);
}

// user
export function userAjaxTable(dateStart,dateEnd){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_user/ajaxTable?language='+language+'&date_start=' + dateStart + '&date_end=' + dateEnd,
		method: 'get'
	});

	return Promise.resolve(data);
}

// summary
export function summary(dateStart,dateEnd,username){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report/summary?language='+language + '&date_start=' + dateStart + '&date_end=' + dateEnd + '&member=' + username,
		method: 'get'
	});

	return Promise.resolve(data);
}

// system log
export function systemLogAjaxTable(limit,pagination,id,created_at,completed_at,code,info,is_done){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report/systemlog/ajaxTable?language='+language +'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&completed_at=' + completed_at + '&code=' + code + '&info=' + info + '&is_done=' + is_done,
		method: 'get'
	});

	return Promise.resolve(data);
}

// summaryGroup
export function summaryInitialize(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report/groupSummary?language='+language,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function summaryDownline(member){
	const data = request({
		url: config.url+'report/getMyDownline?member='+member,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function summaryGroup(date_start,date_end,downline_list,member){
	const data = request({
		url: config.url+'report/groupSummary?date_start='+date_start+'&date_end='+date_end+'&downline_list='+downline_list+'&member='+member,
		method: 'get'
	});

	return Promise.resolve(data);
}

// system pricelog
export function priceLogAjaxTable(date_start,date_end){
	const data = request({
		url: config.url+'report_pricelog/ajaxTable?date_start='+date_start+'&date_end='+date_end,
		method: 'get'
	});

	return Promise.resolve(data);
}

// security
export function securityAjaxTable(limit,pagination,created_at,id,remark,attempt_login,attempt_password,last_ip){
	const data = request({
		url: config.url+'report_security/ajaxTable?limit=' + limit + '&pagination=' + pagination +'&created_at='+created_at+'&id='+id+'&remark='+remark+'&attempt_login='+attempt_login+'&attempt_password='+attempt_password+'&last_ip='+last_ip,
		method: 'get'
	});

	return Promise.resolve(data);
}

// verify
export function verifyAjaxTable(limit,pagination,id,created_at,remark,login,status,type){
	const data = request({
		url: config.url+'report_verify/ajaxTable?limit=' + limit + '&pagination=' + pagination +'&id='+id+'&created_at='+created_at+'&remark='+remark+'&login='+login+'&status='+status+'&type='+type,
		method: 'get'
	});

	return Promise.resolve(data);
}

// vrt transaction
export function vrtTransactionAjaxTable(limit,pagination,transaction_type,date_start){
	const data = request({
		url: config.url+'report_vrtTransaction/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&transaction_type=' + transaction_type + '&date_start=' + date_start,
		method: 'get'
	});

	return Promise.resolve(data);
}

// trust out
export function trustOutAjaxTable(limit,pagination,master_id,total_trust_out,downline_trust_out,date_start,date_end,login){
	const data = request({
		url: config.url+'report_trust_out/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&master_id=' + master_id + '&total_trust_out=' + total_trust_out + '&downline_trust_out=' + downline_trust_out + '&date_start=' + date_start + '&date_end=' + date_end + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

// rank report
export function rankAjaxTable(limit,pagination,id,master_id,created_at,rank_id,login){
	const data = request({
		url: config.url+'report_rank/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&master_id=' + master_id + '&created_at=' + created_at + '&rank_id=' + rank_id + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

// migrateGroup
export function migrateGroupAjaxTable(limit,pagination,id,created_at,master_id,yesterday_entrust,yesterday_terminate,total_amount,average_amount,total_unlock,after_balance,gca_price,downline_number){
	const data = request({
		url: config.url+'report_migrate_group/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&yesterday_entrust=' + yesterday_entrust + '&yesterday_terminate=' + yesterday_terminate + '&total_amount=' + total_amount + '&average_amount=' + average_amount + '&total_unlock=' + total_unlock + '&after_balance=' + after_balance + '&gca_price=' + gca_price + '&downline_number=' + downline_number,
		method: 'get'
	});

	return Promise.resolve(data);
}

// migratePersonal
export function migratePersonalAjaxTable(limit,pagination,id,created_at,master_id,yesterday_entrust,yesterday_terminate,total_amount,average_amount,total_unlock,after_balance,gca_price,downline_number){
	const data = request({
		url: config.url+'report_migrate_group/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&yesterday_entrust=' + yesterday_entrust + '&yesterday_terminate=' + yesterday_terminate + '&total_amount=' + total_amount + '&average_amount=' + average_amount + '&total_unlock=' + total_unlock + '&after_balance=' + after_balance + '&gca_price=' + gca_price + '&downline_number=' + downline_number,
		method: 'get'
	});

	return Promise.resolve(data);
}

// validDownline
export function validDownlineAjaxTable(limit,pagination,id,created_at,master_id,daily_wallet_amount,valid_downline,self_valid){
	const data = request({
		url: config.url+'report_valid_downline/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&daily_wallet_amount=' + daily_wallet_amount + '&valid_downline=' + valid_downline + '&self_valid=' + self_valid,
		method: 'get'
	});

	return Promise.resolve(data);
}

// shopping report
export function shoppingRecordAjaxTable(limit,pagination,id,created_at,completed_at,shopping_product_id,code,refer_code,master_id,total_amount,status,shopping_status_id,login){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_shopping/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination  + '&id=' + id  + '&created_at=' + created_at  + '&completed_at=' + completed_at  + '&shopping_product_id=' + shopping_product_id  + '&code=' + code  + '&refer_code=' + refer_code  + '&master_id=' + master_id  + '&total_amount=' + total_amount  + '&status=' + status  + '&shopping_status_id=' + shopping_status_id + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function shoppingRecordInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_shopping/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

// member log
export function memberLogAjaxTable(limit,pagination,id,created_at,master_id,remark,ip){
	const data = request({
		url: config.url+'report_member_log/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&master_id=' + master_id + '&remark=' + remark + '&ip=' + ip,
		method: 'get'
	});

	return Promise.resolve(data);
}

// member trust out
export function memberTrustOutAjaxTable(limit,pagination,User,member,completed_at){
	const data = request({
		url: config.url+'report_member_trust_out/ajaxTable?limit=' + limit + '&pagination=' + pagination + '&login=' + User + '&member=' + member + '&completed_at=' + completed_at,
		method: 'get'
	});

	return Promise.resolve(data);
}

// gplay topup
export function GPlayTopupRecordAjaxTable(limit,pagination,id,created_at,code,master_id,game_id,total_amount,status,member){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_bts_topup/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&game_id=' + game_id + '&total_amount=' + total_amount + '&status=' + status + '&member=' + member,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function GPlayTopupRecordInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_bts_topup/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

// gplay withdraw
export function GPlayWithdrawRecordAjaxTable(limit,pagination,id,created_at,code,master_id,game_id,total_amount,status,member){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_bts_withdraw/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&game_id=' + game_id + '&total_amount=' + total_amount + '&status=' + status + '&member=' + member,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function GPlayWithdrawRecordInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'report_bts_withdraw/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}